import Unifier from "../../../components/DataCollection/Unifier/Unifier";
const UnifierScreen = () => {
  return <Unifier />;
};

export default UnifierScreen;
